import { query, serviceQueries } from 'elc-service-bus';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { observable } from 'mobx';
import { ProductRepository } from '../repositories/ProductRepository';
import { IProduct } from '../interfaces/IRating';

export class RatingsLoadedUseCase {
    @observable public productRepository: ProductRepository;
    @observable public productId: string;

    constructor(productId: string) {
        this.productId = productId;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = async () => {
        // tslint:disable-next-line: await-promise
        const products = await query(serviceQueries.GET_PRODUCTS_V2, [this.productId]);

        this.productRepository.setProducts(products as IProduct[]);
    };
}
